module.exports = __webpack_public_path__ + "img/login_background2.3c5a26c8.jpg";